module.exports = __webpack_public_path__ + "img/units.eb0b80cd.svg";